var map = {
	"./small_castle.png": 46705,
	"./small_diamond.png": 72917,
	"./small_dragon.png": 9871,
	"./small_flag.png": 66543,
	"./small_king.png": 7060,
	"./small_map.png": 20327,
	"./small_medal.png": 97912,
	"./small_prince.png": 88382,
	"./small_princess.png": 46652,
	"./small_queen.png": 6023,
	"./small_treasure.png": 23798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60885;